import { render, staticRenderFns } from "./horizontal-list.vue?vue&type=template&id=1ad4d9d0&"
import script from "./horizontal-list.vue?vue&type=script&lang=ts&"
export * from "./horizontal-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports